import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LoadMoreCTA, LoadMoreWrapper } from './LoadMore.style';
import { FilteredVehicle } from '../../types';
import { addMoreVehicles } from '../../redux/vehicleListReducer';
import Spinner from '../Spinner';

interface LodeMoreTypes {
  fetchMore: (args: { variables: any; updateQuery: any }) => void;
  vehiclesList: FilteredVehicle[];
  isLoadingMore: boolean;
  setIsLoadingMore: (arg: boolean) => void;
}

const LoadMore: React.FC<LodeMoreTypes> = ({
  fetchMore,
  vehiclesList,
  isLoadingMore,
  setIsLoadingMore,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetchMoreVehicles = () => {
    setIsLoadingMore(true);
    fetchMore({
      variables: {
        offset: vehiclesList.length,
      },
      updateQuery: (_prev: { getFilteredVehiclesForWormwood: any }, newData: any) => {
        const queryResults = newData.fetchMoreResult.getFilteredVehiclesForWormwood.vehicles;
        setIsLoadingMore(false);
        dispatch(addMoreVehicles(queryResults));
      },
    });
  };
  return (
    <LoadMoreWrapper>
      {isLoadingMore ? (
        <Spinner size={40} />
      ) : (
        <LoadMoreCTA onClick={fetchMoreVehicles}>{t('vlp.vehicleResults.loadMore')}</LoadMoreCTA>
      )}
    </LoadMoreWrapper>
  );
};

export default LoadMore;
